module["exports"] = [
  "#{Address.state} #{creature}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/team/name.js
// module id = 1275
// module chunks = 0